<script setup>
  import { ref, computed, watchEffect} from 'vue';

  const props = defineProps({
    value: {
      type: Number,
      required: true
    },
    position: {
      type: Object,
      required: true
    },
    lineColor: {
      type: String,
      required: true
    },
    isNext: {
      type: Boolean,
      required: true
    },
    graph: {
      type: [Object, null],
      required: true
    }
  });

  const markerPosition = ref({ x: 0, y: 0 });
  const graph = ref(props.graph)

  const isInFuture = computed(() => props.value > Date.now());

  const labelStyle = computed(() => {
    return {
      position: 'absolute',
      left: `${markerPosition.value.x + props.graph.plotLeft}px`,
      top: `${markerPosition.value.y}px`,
      '--jwx-tide-graph-event-marker-border-color': isInFuture.value ? props.lineColor : 'hsla(0, 0%, 61%, 1.0)'
    };
  });

  watchEffect(() => {
    if (props.position) {
      markerPosition.value = props.position;
    }
  });
</script>

<template>
  <Teleport :to="graph.container">
    <div
      class="jwx-tide-graph__event-marker"
      :data-is-next="props.isNext"
      :style="labelStyle"
    ></div>
  </Teleport>
</template>